<template>
  <div class="req-status">
    <p v-if="!data || data.length < 1" class="no_data">
      {{ $lange == "en" ? "No Data" : "暂无数据" }}
    </p>
    <e-charts
      v-else
      style="width: 100%"
      :options="options"
      auto-resize
    ></e-charts>
  </div>
</template>

<script>
// 请求数据-按状态

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/pie";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";
import theme from "./theme";

export default {
  name: "RequestEmpPie",
  components: { ECharts },
  props: {
    data: {
      type: Array,
    },
  },

  computed: {
    options() {
      const seriesData = this.data.map((item) => ({
        name: item.code,
        value: item.counter,
      }));
      return {
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        legend: {
          left: 32,
          top: 6,
        },
        ...theme,
        series: [
          {
            name: "处理人",
            type: "pie",
            radius: "55%",
            data: seriesData,
            label: {
              formatter: "{d}%",
            },
            top: 80
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
.req-status {
  width: 100%;
}
</style>
